import { BsFillPersonFill } from "react-icons/bs";

export interface PriceAndCapacityProps {
  priceFrom: number;
  capacity: number;
  additionalCapacity?: number;
}

export const PriceAndCapacity = ({
  // TODO: uncomment when phase 3 is completed from BE
  // @ts-ignore
  // eslint-disable-next-line
  priceFrom,
  capacity,
  additionalCapacity = 0,
}: PriceAndCapacityProps) => {
  const renderAdditionalCapacity = () => {
    if (additionalCapacity > 0) {
      return <>+{renderCapacity(additionalCapacity)}</>;
    }
  };

  const renderCapacity = (capacity: number) => {
    if (capacity > 5) {
      return (
        <>
          <p className="u-p0 u-text-dark">{capacity} x</p>
          <BsFillPersonFill fill={"#04172F"} size={20} />
        </>
      );
    }

    return (
      <>
        {Array.from({ length: capacity })?.map((_, index) => (
          <BsFillPersonFill key={index} fill={"#04172F"} size={20} />
        ))}
        {}
      </>
    );
  };

  return (
    <div className="c-price-and-capacity">
      {/* TODO: uncomment when phase 3 is completed from BE */}
      {/*<h6 className="c-price-and-capacity__price u-p0 u-text-dark">*/}
      {/*<span className="u-fw-600">*/}
      {/*{t("from")} {formatCurrency(priceFrom, "EUR", 0)}*/}
      {/*</span>*/}
      {/*</h6>*/}
      <div className="priceAndCapacity c-price-and-capacity__capacity u-p0">
        {renderCapacity(capacity)}
        {renderAdditionalCapacity()}
      </div>
    </div>
  );
};
